import React from 'react';
import { Form, FormGroup, Col, FormControl, ControlLabel, Button, Alert } from 'react-bootstrap';

import axios from 'axios';
import constants from '../util/constants';

import NPPanel from '../NPPanel';

const { API_BASE_URL } = constants;

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);

    this.postChangePassword = this.postChangePassword.bind(this);

    this.state = {
      isResetMailSent: false,
      hasErrorOccured: false,
      resetPasswordForEmail: '',
    }
  }

  postChangePassword() {
    const self = this;

    const email = this.state.resetPasswordForEmail;
    const path = 'Account/ResetPassword';

    axios.post(API_BASE_URL + path, {
        Email: email,
        Base: process.env.REACT_APP_BASE_CATALOG
    })
    .then(function (response) {
      self.setState({
        isResetMailSent: true,
        hasErrorOccured: false,
      });
    })
    .catch(function (error) {
      self.setState({
        isResetMailSent: false,
        hasErrorOccured: true,
      });
    });
  }

  render() {
    const { isResetMailSent, hasErrorOccured } = this.state;

    return (<NPPanel title="Password reset" small centered>
      <Form horizontal autoComplete="off" onSubmit={evt => { evt.preventDefault(); this.postChangePassword(); }}>
        {isResetMailSent && <Alert bsStyle="success"><p>An email with instructions to reset your password has been sent to: {this.state.resetPasswordForEmail}.</p></Alert>}
        {hasErrorOccured && <Alert bsStyle="danger"><p>An email with instructions to reset your password could not be sent to: {this.state.resetPasswordForEmail}.</p></Alert>}

        <FormGroup controlId="formHorizontalEmail">
          <Col componentClass={ControlLabel} sm={2}>
            Email
          </Col>
          <Col sm={10}>
            <FormControl type="text" placeholder="name@email.com" onChange={evt => { this.setState({ resetPasswordForEmail: evt.target.value }) }}/>
          </Col>
        </FormGroup>

        <FormGroup>
          <Col smOffset={2} sm={10}>
            <Button type="button" bsStyle="primary" onClick={this.postChangePassword}>
              Request password reset
            </Button>
          </Col>
        </FormGroup>
      </Form>
    </NPPanel>)
  }
}

export default ForgotPassword;